import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'

export const ModalContent = styled.div`
  width: 380px;
  ${bp('sm')`
    width: 100%;
    box-sizing: border-box;
  `}

  p {
    margin: 0 0 20px;
    user-select: none;
    color: ${props => props.theme.palette.general.greyDark};
  }
`
